var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center problem-number-div"},[_c('p',{staticClass:"display-4"},[_vm._v(_vm._s(this.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }